<template>
  <div>
    <div class="flex justify-between items-center">
      <div>
        <h1>
          {{ factorRequest.business.currency.code
          }}{{ factorRequest.amount / factorRequest.business.currency.factor }}
        </h1>
        <p>{{ factorRequest.business.name }}</p>
      </div>
      <div class="flex">
        <el-button
          v-if="factorRequest.state == 'pending'"
          size="small"
          round
          @click="approveFactorRequest"
          >Approve</el-button
        >
        <el-button
          v-if="factorRequest.state == 'pending'"
          size="small"
          round
          @click="declineFactorRequest"
          >Decline</el-button
        >
      </div>
    </div>

    <div class="bg-white shadow-lg rounded-lg mt-10 p-6 w-1/2">
      <small>Linked invoice</small>
      <hr class="mt-2 mb-4" />

      <h2 class="mb-6">{{ factorRequest.invoice.customer.name }}</h2>

      <label>Amount</label>
      <p class="mb-6">
        {{ factorRequest.business.currency.code
        }}{{
          factorRequest.invoice.netAmount /
            factorRequest.business.currency.factor
        }}
      </p>

      <label>Due date</label>
      <p>{{ factorRequest.invoice.dueDate | moment("dddd, Mo MMM YYYY") }}</p>
    </div>
  </div>
</template>

<script>
import { FACTOR_REQUEST_QUERY } from "@/api/queries";
import {
  APPROVE_FACTOR_REQUEST_MUTATION,
  DECLINE_FACTOR_REQUEST_MUTATION
} from "@/api/mutations";

export default {
  apollo: {
    factorRequest: {
      query: FACTOR_REQUEST_QUERY,
      variables() {
        return { id: Number.parseInt(this.$route.params.id) };
      }
    }
  },
  data() {
    return {
      factorRequest: {
        amount: 0,
        business: {
          currency: {}
        },
        invoice: {
          customer: {}
        }
      }
    };
  },
  methods: {
    async approveFactorRequest() {
      const { data } = await this.$apollo.mutate({
        mutation: APPROVE_FACTOR_REQUEST_MUTATION,
        variables: { id: this.$route.params.id }
      });

      if (data.approveFactorRequest.status == 200) {
        this.factorRequest.state = "approved";
        this.toastMessage("Factor request approved");
      }
    },
    async declineFactorRequest() {
      const { data } = await this.$apollo.mutate({
        mutation: DECLINE_FACTOR_REQUEST_MUTATION,
        variables: { id: this.$route.params.id }
      });

      if (data.declineFactorRequest.status == 200) {
        this.factorRequest.state = "declined";
        this.toastMessage("Factor request declined");
      }
    }
  }
};
</script>
